<template>
  <div class="home">
    <!-- 顶部内容 -->
    <HomeBannerTop></HomeBannerTop>
    <!-- <div>
      <img src="@/assets/home/cn/banner2.png" />
    </div> -->
    <!-- 搜索 -->
    <div class="home-search flex-center">
      <div class="m-r-10">
        <!-- <input v-model="searchValue" size="small" class="home-search-input" :placeholder="$t('输入供应商，产品或展位名称搜索')"> -->
        <el-input class="home-search-input" :placeholder="$t('输入供应商，产品或展位名称搜索')" prefix-icon="el-icon-search"
          v-model="searchValue">
        </el-input>
      </div>
      <div class="flex flex-start">
        <div class="m-r-10 home-search-btn pointer" @click="goSrarch('sousuo')">
          <img src="@/assets/home/cn/sousuo.png" />
          <span>{{$t('搜索')}}</span>
        </div>
        <div class="home-search-btn pointer" @click="goSrarch('fenlei')">
          <img src="@/assets/home/cn/fenlei.png" />
          <span>{{ $t('展商名录') }}</span>
        </div>
      </div>
    </div>
    <!-- 分类 -->
    <div class="home-fenlei flex-center">
      <el-row :gutter="20">
        <el-col :xs="12" :sm="12" :md="6" :lg="6" v-for="(item,index) in this.bannerHotIndustryList" :key="index">
          <div style="position: relative;" @click="goSrarch('zhanqu', item)">
            <img :src="item.coverIcon" class="pointer" />
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 展馆 -->
    <div class="home-zhanguan">
      <div class="home-zhanguan-main flex-center pointer" @click="goBoothMap()">
        <template v-if="language == 'en'">
          <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/home/zhanguanfenbu_en.png" />
        </template>
        <template v-else>
          <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/home/zhanguanfenbu_cn.png" />
        </template>
      </div>
    </div>
    <!-- 会议周 首页轮播图1 -->
    <div class="home-huiyizhou flex-center">
      <!-- <img src="@/assets/home/cn/huiyizhou.png" class="pointer" /> -->
      <swiper :options="swiperOption" class="swiper-container" v-if="bannerSwiper1.length > 1">
        <swiper-slide class="swiper-slide" v-for="(item, index) in bannerSwiper1" :key="index">
          <a href="javascript:void(0)" @click="openUrl(option[index])">
            <img :src="item.coverIcon" :item="JSON.stringify(item)" />
          </a>
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination" />
      </swiper>
      <template v-else-if="bannerSwiper1.length == 1">
        <div class="singleBox" style="">
          <a href="javascript:void(0)" @click="openUrl(bannerSwiper1[0])">
            <img :src="bannerSwiper1[0].coverIcon" />
          </a>
        </div>
      </template>
    </div>
    <!-- 支持单位 -->
    <div class="home-support-unit">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" class="home-support-unit-col" v-if="bannerSponsor.length >= 1">
          <div style="width:100%;text-align: center;padding:16px">
            <span style="display: inline-block;padding:0 10px;">
              <div class="home-support-unit-title">{{ $t('赞助企业')}}</div>
              <div class="home-support-unit-bg"></div>
            </span>
          </div>
          <div class="home-support-unit-box">
            <swiper :options="swiperOption1" class="swiper-container" v-if="bannerSponsor.length > 0">
              <swiper-slide class="swiper-slide" v-for="(item, index) in bannerSponsor" :key="index">
                <div class="swiper-div" @click="openBlankUrl(item)">
                  <img :src="item.coverIcon" />
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" class="home-support-unit-col"
          v-if="bannerAssociatedMedia.length >= 1">
          <div style="width:100%;text-align: center;padding:16px">
            <span style="display: inline-block;padding:0 10px;">
              <div class="home-support-unit-title">{{ $t('合作媒体')}}</div>
              <div class="home-support-unit-bg"></div>
            </span>
          </div>
          <div class="home-support-unit-box">
            <swiper :options="swiperOption1" class="swiper-container" v-if="bannerAssociatedMedia.length > 0">
              <swiper-slide class="swiper-slide" v-for="(item, index) in bannerAssociatedMedia" :key="index">
                <div class="swiper-div" @click="openBlankUrl(item)">
                  <img :src="item.coverIcon" />
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 首页轮播图2 -->
    <div class="home-huiyizhou flex-center">
      <!-- <img src="@/assets/home/cn/huiyizhou.png" class="pointer" /> -->
      <swiper :options="swiperOption" class="swiper-container" v-if="bannerSwiper2.length > 1">
        <swiper-slide class="swiper-slide" v-for="(item, index) in bannerSwiper2" :key="index">
          <a href="javascript:void(0)" @click="openUrl(option[index])">
            <img :src="item.coverIcon" :item="JSON.stringify(item)" />
          </a>
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination" />
      </swiper>
      <template v-else-if="bannerSwiper2.length == 1">
        <div class="singleBox" style="">
          <a href="javascript:void(0)" @click="openUrl(bannerSwiper2[0])">
            <img :src="bannerSwiper2[0].coverIcon" />
          </a>
        </div>
      </template>
    </div>
    <!-- 合作媒体 -->
    <div class="home-support-unit flex-center" style="margin-top: 16px;" v-if="false">
      <el-row style="width:100%">
        <el-col :span="24">
          <div style="width:100%;text-align: center;padding:16px">
            <span style="display: inline-block;padding:0 10px;">
              <div class="home-support-unit-title">合作媒体</div>
              <div class="home-support-unit-bg"></div>
            </span>
          </div>
          <div class="home-support-unit-box">
            <div class="home-support-unit-div-medium">
              <p>央视网</p>
              <p>北京电视台</p>
              <p>中文国际</p>
            </div>
            <div class="vertical-bar"></div>
            <div class="home-support-unit-div-medium">
              <p>中国网络电视台</p>
              <p>凤凰卫视</p>
              <p>河北卫视</p>
            </div>
            <div class="vertical-bar"></div>
            <div class="home-support-unit-div-medium">
              <p>人民网</p>
              <p>新华网</p>
              <p>中国青年网</p>
            </div>
            <div class="vertical-bar"></div>
            <div class="home-support-unit-div-medium">
              <p>优酷视频</p>
              <p>搜狐视频</p>
              <p>腾讯视频</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 底部信息 -->
    <HomeFooter></HomeFooter>
  </div>
</template>

<script>
import '../styles/index.styl'
import { mapState, mapGetters } from 'vuex'
// 首页 搜索
import HomeSearchInput from './index/HomeSearchInput'
// 顶部内容
import HomeBannerTop from './index/HomeBannerTop'
// 底部内容
import HomeFooter from './index/HomeFooter'

import zhibao from '@/assets/home/cn/zhibao.png'
import feiliao from '@/assets/home/cn/feiliao.png'
import nonghua from '@/assets/home/cn/nonghua.png'
import nongyekeji from '@/assets/home/cn/nongyekeji.png'

import {
  getConfigurationItemList,
  getRecommendProductList,
  getQueryList
} from '@/api/home'

export default {
  name: 'Home',
  components: {
    'v-search-input': HomeSearchInput,
    HomeBannerTop,
    HomeFooter,
  },
  data() {
    return {
      searchValue: '', // 搜索值
      // swiper配置
      swiperOption: {
        slidesPerView: 'auto',
        // autoplay: false,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      // 垂直滚动配置
      swiperOption1: {
        direction: 'vertical',
        slidesPerView: 3,
        loop: true,
        loopFillGroupWithBlank: true,
        autoplay: {
          delay: 3000
        },
        // autoplay: {
        //   disableOnInteraction: false,
        //   delay: 3000
        // }
      },
      bannerList: [], // 顶部轮播图 
      bannerHotIndustryList: [], // 顶部热门产业轮播图 
      bannerSwiper1: [], // 电子会刊轮播图1
      bannerSwiper2: [], // 电子会刊轮播图2
      bannerSponsor: [], // pc电子会刊轮播图赞助企业
      bannerAssociatedMedia: [], // pc电子会刊轮播图合作媒体
    }
  },
  computed: {
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType', 'fromUrl'])
  },
  metaInfo() {
    const isChinese = this.$store.getters.language !== 'en';

    if (isChinese) {
      return {
        title: 'CAC - 中国国际农用化学品及植保展览会',
        meta: [
          {
            name: 'description',
            content: '中国国际农用化学品及植保展览会,于 1999 年首次举办。第二十六届中国国际农用化学品及植保展览会（CAC2026）将在国家会展中心（上海）1.2 馆、2.2 馆、5.2 馆、6.2 馆、7.2 馆、8.2 馆举办,展出面积达到 16 万平方米。 CAC2026 展期将举办中国国际植保展览会（CropProtection）、中国国际新型肥料展览会（FSHOW）、中国国际农化装备及植保器械展览会（CACE）、中国国际现代农业科技展览会（AgTech）及 CAC 会议周（CACW）等分题展览及行业专题会议,届时将有 2,200 余家知名展商汇聚在农化的世界,与 100,000余人次的海内外业内人士共商世界的农化。'
          },
          {
            name: 'keywords',
            content: '植保器械展会,农药原药展会,农业机械展会,上海农化展览会,生物农药展会,农化装备展会,中国国际农药展,中国农药展会,最近农展会,中国(上海)国际农用化学品及植保展览会,助农展销会,农药展销会在哪里举办,农药展览,上海近期农展会,中国肥料展,农药中间体展会,农药展会,农药展销会,肥料展会,上海农化展会,中国农药展览会,中国农展会,上海农药原药展览会,上海农展会在什么地方,上海农资展会,国际农化展,上海农展会,上海农化展,农化展会,植保展会,农化展2026,2026上海农药展,近期农业展会,2026杭州农药展会,cac农化展2026,2026植保展,农业展会2026,2026上海农药展会,2026农展会,2026年农展会,农药展会2026时间表,农业展会2026时间表,2026年农资展览会,上海农药展会2026,上海农化展会2026,2026年农资展会时间表,2026年农业展会有哪些,2026植保展会,2026年农药展会,2026农化展,2026年农产品展会,农药展2026,2026农资展会,植保展,农展网,2026年全国农药展览会,农资展会,2026上海国际农药助剂展览会,2026年植保展会时间表,2026年农产品展览会,2026年农资展会,上海cac农化展,化肥展,北京农展会,上海国际农化展,2026年农药展会时间表,2026农药展览会,农展会,2026农药展,农资展览,全国农药展会,全国农业展会,青岛农药展会,农业展览馆近期展会,上海肥料展,上海肥料展会,国际农业展会,上海植保展,农展会信息,2026农产品展会,新型肥料展会,上海国际农化展cac,农资展览会,农资展销会,农化产品展,cac农药展2026,农展会2026年时间表格,2026农化展会,农业展会2026年,全国农药交流会暨农化产品展览会,上海植保展会,微生物农药研究进展,全国植保展,肥料展览会,国内农业展会,ace农药展会,中国国际肥料展览会,ace农药展,上海农药展,上海农药展会,上海原药展,cac农药展,农业设备展会,农业展销会博览会,农牧展会,农药助剂展,国际肥料展会,国际肥料展览会,cac农化展,农展馆最近展会,农化展,农药展览会,上海农药助剂展,农药展,cac上海农药展会,北京农展,农展,2026农药展会,全国农展会,全国农药交流会暨农化产品展览会,2026年中国农产品展览会,肥料展,农药国际展会,农药化肥展会,农用化学品（agrochemical）,农药（pesticide）,肥料（fertilizer）,植保（Crop protection）,herbicide (除草剂),insecticide （杀虫剂）,fungicide （杀菌剂）, biopesticide,Seed,specialty fertilizer (特种肥),npk（氮磷钾）,compound fertilizer（复合肥）'
          }
        ],
        link: [
          {
            rel: 'canonical',
            href: 'https://cacizt-pc.eastfair.com/'
          }
        ]
      };
    } else {
      return {
        title: 'CAC - China International Agrochemical & Crop Protection Exhibition',
        meta: [
          {
            name: 'description',
            content: 'China International Agrochemical& Crop Protection Exhibition (CAC),was first launched in 1999. CAC2026 will be held at National Exhibition and Convention Center (Shanghai),at Halls 1.2,2.2,5.2,6.2,7.2 and 8.2,with a total exhibition space of 160,000 square meters. CAC2026 features several sub-exhibitions and industry conferences,including China International Crop Protection Exhibition(CropProtection),China International Fertilizer Show (FSHOW),China International Agrochemical & Crop Protection Equipment Exhibition(CACE),and China International AgTech Exhibition (AgTech),as well as CAC Conference Week (CACW). CAC2026 will bring together more than 2,200 leading exhibitors and over 100,000 attendance of industry professionals from home and abroad to explore globalagrochemical developments.'
          },
          {
            name: 'keywords',
            content: '植保器械展会,农药原药展会,农业机械展会,上海农化展览会,生物农药展会,农化装备展会,中国国际农药展,中国农药展会,最近农展会,中国(上海)国际农用化学品及植保展览会,助农展销会,农药展销会在哪里举办,农药展览,上海近期农展会,中国肥料展,农药中间体展会,农药展会,农药展销会,肥料展会,上海农化展会,中国农药展览会,中国农展会,上海农药原药展览会,上海农展会在什么地方,上海农资展会,国际农化展,上海农展会,上海农化展,农化展会,植保展会,农化展2026,2026上海农药展,近期农业展会,2026杭州农药展会,cac农化展2026,2026植保展,农业展会2026,2026上海农药展会,2026农展会,2026年农展会,农药展会2026时间表,农业展会2026时间表,2026年农资展览会,上海农药展会2026,上海农化展会2026,2026年农资展会时间表,2026年农业展会有哪些,2026植保展会,2026年农药展会,2026农化展,2026年农产品展会,农药展2026,2026农资展会,植保展,农展网,2026年全国农药展览会,农资展会,2026上海国际农药助剂展览会,2026年植保展会时间表,2026年农产品展览会,2026年农资展会,上海cac农化展,化肥展,北京农展会,上海国际农化展,2026年农药展会时间表,2026农药展览会,农展会,2026农药展,农资展览,全国农药展会,全国农业展会,青岛农药展会,农业展览馆近期展会,上海肥料展,上海肥料展会,国际农业展会,上海植保展,农展会信息,2026农产品展会,新型肥料展会,上海国际农化展cac,农资展览会,农资展销会,农化产品展,cac农药展2026,农展会2026年时间表格,2026农化展会,农业展会2026年,全国农药交流会暨农化产品展览会,上海植保展会,微生物农药研究进展,全国植保展,肥料展览会,国内农业展会,ace农药展会,中国国际肥料展览会,ace农药展,上海农药展,上海农药展会,上海原药展,cac农药展,农业设备展会,农业展销会博览会,农牧展会,农药助剂展,国际肥料展会,国际肥料展览会,cac农化展,农展馆最近展会,农化展,农药展览会,上海农药助剂展,农药展,cac上海农药展会,北京农展,农展,2026农药展会,全国农展会,全国农药交流会暨农化产品展览会,2026年中国农产品展览会,肥料展,农药国际展会,农药化肥展会,农用化学品（agrochemical）,农药（pesticide）,肥料（fertilizer）,植保（Crop protection）,herbicide (除草剂),insecticide （杀虫剂）,fungicide （杀菌剂）, biopesticide,Seed,specialty fertilizer (特种肥),npk（氮磷钾）,compound fertilizer（复合肥）'
          }
        ],
        link: [
          {
            rel: 'canonical',
            href: 'https://cacizt-pc.eastfair.com/'
          }
        ]
      };
    }
  },
  methods: {
    // 展馆分布
    goBoothMap() {
      this.$router.push({
        path: '/boothMapList'
      })
    },
    // 跳转链接
    openUrl(data) {
      if (data.type == 'EXTERNAL' && data.url) {
        window.open(data.url, '_blank')
      }
    },
    openBlankUrl(data) {
      if (data.urlType == 'EXTERNAL' && data.url) {
        window.open(data.url, '_blank')
      }
    },
    // 搜索
    goSrarch(type, param) {
      if (type == 'sousuo') {
        if (this.searchValue) {
          console.log('跳转')
          this.$router.push({
            path: '/actorList',
            query: {
              keywords: this.searchValue
            }
          })
        } else {
          this.$alert(this.$t('输入供应商，产品或展位名称搜索'), this.$t('tips'), {
            confirmButtonText: this.$t('common.ok')
          });
        }
      } else if (type == 'zhanqu') {
        console.log('param--->', param)

        if (param.urlType == 'EXTERNAL') {
          if (param.url === '') {
            return
          } else {
            window.open(param.url, '_blank')
          }
        } else {
          if (param.urlType == "LIST_EXHIBITOR") {
            this.$router.push({ path: '/actorList', query: { type: param.url, code: param.title } })
          } else {
            console.log('暂时没有匹配操作')
          }
        }
      } else {
        this.$router.push({
          path: '/actorList',
        })
      }
      console.log('searchValue--->', this.searchValue)
    },
    // 排序
    sortSequence(a, b) {
      return a.sequence - b.sequence
    },
    // 获取首页顶部bannner
    getHomeTopBannerList() {
      getConfigurationItemList({
        sourceType: 1
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 && res.data) {
            // 顶部轮播图
            if (res.data.bannerMap['PC_JOURNAL_TOP_BANNER'] && res.data.bannerMap['PC_JOURNAL_TOP_BANNER'].length != 0) {
              for (let i in res.data.bannerMap['PC_JOURNAL_TOP_BANNER']) {
                console.log(res.data.bannerMap['PC_JOURNAL_TOP_BANNER'][i]['urlType'], "res.data.bannerMap['PC_JOURNAL_TOP_BANNER'][i]['urlType']")
                if (res.data.bannerMap['PC_JOURNAL_TOP_BANNER'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['PC_JOURNAL_TOP_BANNER'][i]['urlType'] === 'TAG_EXHIBITOR' || res.data.bannerMap['PC_JOURNAL_TOP_BANNER'][i]['urlType'] === 'ACTOR_DETAILS' || res.data.bannerMap['PC_JOURNAL_TOP_BANNER'][i]['urlType'] === 'TAG_PRODUCT') {
                  this.bannerList.push(res.data.bannerMap['PC_JOURNAL_TOP_BANNER'][i])
                }
              }
              this.bannerList.sort(this.sortSequence)
            }

            // 首页热门产业
            if (res.data.bannerMap['PC_JOURNAL_HOT_INDUSTRY'] && res.data.bannerMap['PC_JOURNAL_HOT_INDUSTRY'].length != 0) {
              for (let i in res.data.bannerMap['PC_JOURNAL_HOT_INDUSTRY']) {
                if (
                  // res.data.bannerMap['PC_JOURNAL_HOT_INDUSTRY'][i]['urlType'] === 'EXTERNAL' ||
                  // res.data.bannerMap['PC_JOURNAL_HOT_INDUSTRY'][i]['urlType'] === 'TAG_EXHIBITOR' ||
                  // res.data.bannerMap['PC_JOURNAL_HOT_INDUSTRY'][i]['urlType'] === 'ACTOR_DETAILS' ||
                  // res.data.bannerMap['PC_JOURNAL_HOT_INDUSTRY'][i]['urlType'] === 'TAG_PRODUCT' ||
                  // res.data.bannerMap['PC_JOURNAL_HOT_INDUSTRY'][i]['urlType'] === 'PRODUCT_DETAILS' ||
                  res.data.bannerMap['PC_JOURNAL_HOT_INDUSTRY'][i]['urlType'] === 'LIST_EXHIBITOR'
                ) {
                  this.bannerHotIndustryList.push(res.data.bannerMap['PC_JOURNAL_HOT_INDUSTRY'][i])
                }
              }
              this.bannerHotIndustryList.sort(this.sortSequence)
            }
            console.log('this.bannerHotIndustryList:', this.bannerHotIndustryList)
            // pc电子会刊轮播图1
            if (res.data.bannerMap['PC_JOURNAL_SWIPER1'] && res.data.bannerMap['PC_JOURNAL_SWIPER1'].length != 0) {
              for (let i in res.data.bannerMap['PC_JOURNAL_SWIPER1']) {
                if (
                  res.data.bannerMap['PC_JOURNAL_SWIPER1'][i]['urlType'] === 'EXTERNAL' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER1'][i]['urlType'] === 'TAG_EXHIBITOR' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER1'][i]['urlType'] === 'ACTOR_DETAILS' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER1'][i]['urlType'] === 'TAG_PRODUCT' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER1'][i]['urlType'] === 'PRODUCT_DETAILS' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER1'][i]['urlType'] === 'LIST_EXHIBITOR'
                ) {
                  this.bannerSwiper1.push(res.data.bannerMap['PC_JOURNAL_SWIPER1'][i])
                }
                // this.bannerSwiper1.push(res.data.bannerMap['PC_JOURNAL_SWIPER1'][i])
              }
              this.bannerSwiper1.sort(this.sortSequence)
            }

            console.log('this.bannerSwiper1:', this.bannerSwiper1)

            // pc电子会刊轮播图2
            if (res.data.bannerMap['PC_JOURNAL_SWIPER2'] && res.data.bannerMap['PC_JOURNAL_SWIPER2'].length != 0) {
              for (let i in res.data.bannerMap['PC_JOURNAL_SWIPER2']) {
                if (
                  res.data.bannerMap['PC_JOURNAL_SWIPER2'][i]['urlType'] === 'EXTERNAL' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER2'][i]['urlType'] === 'TAG_EXHIBITOR' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER2'][i]['urlType'] === 'ACTOR_DETAILS' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER2'][i]['urlType'] === 'TAG_PRODUCT' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER2'][i]['urlType'] === 'PRODUCT_DETAILS' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER2'][i]['urlType'] === 'LIST_EXHIBITOR'
                ) {
                  this.bannerSwiper2.push(res.data.bannerMap['PC_JOURNAL_SWIPER2'][i])
                }
                // this.bannerSwiper2.push(res.data.bannerMap['PC_JOURNAL_SWIPER2'][i])
              }
              this.bannerSwiper2.sort(this.sortSequence)
            }

            console.log('this.bannerSwiper2:', this.bannerSwiper2)

            // pc电子会刊轮播图赞助企业
            if (res.data.bannerMap['PC_JOURNAL_SWIPER_SPONSOR'] && res.data.bannerMap['PC_JOURNAL_SWIPER_SPONSOR'].length != 0) {
              for (let i in res.data.bannerMap['PC_JOURNAL_SWIPER_SPONSOR']) {
                if (
                  res.data.bannerMap['PC_JOURNAL_SWIPER_SPONSOR'][i]['urlType'] === 'EXTERNAL' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER_SPONSOR'][i]['urlType'] === 'TAG_EXHIBITOR' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER_SPONSOR'][i]['urlType'] === 'ACTOR_DETAILS' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER_SPONSOR'][i]['urlType'] === 'TAG_PRODUCT' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER_SPONSOR'][i]['urlType'] === 'PRODUCT_DETAILS' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER_SPONSOR'][i]['urlType'] === 'LIST_EXHIBITOR'
                ) {
                  this.bannerSponsor.push(res.data.bannerMap['PC_JOURNAL_SWIPER_SPONSOR'][i])
                }
                // this.bannerSponsor.push(res.data.bannerMap['PC_JOURNAL_SWIPER_SPONSOR'][i])
              }
              this.bannerSponsor.sort(this.sortSequence)
            }

            console.log('this.bannerSponsor:', this.bannerSponsor)

            //  pc电子会刊轮播图合作媒体
            if (res.data.bannerMap['PC_JOURNAL_SWIPER_ASSOCIATED_MEDIA'] && res.data.bannerMap['PC_JOURNAL_SWIPER_ASSOCIATED_MEDIA'].length != 0) {
              for (let i in res.data.bannerMap['PC_JOURNAL_SWIPER_ASSOCIATED_MEDIA']) {
                if (
                  res.data.bannerMap['PC_JOURNAL_SWIPER_ASSOCIATED_MEDIA'][i]['urlType'] === 'EXTERNAL' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER_ASSOCIATED_MEDIA'][i]['urlType'] === 'TAG_EXHIBITOR' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER_ASSOCIATED_MEDIA'][i]['urlType'] === 'ACTOR_DETAILS' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER_ASSOCIATED_MEDIA'][i]['urlType'] === 'TAG_PRODUCT' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER_ASSOCIATED_MEDIA'][i]['urlType'] === 'PRODUCT_DETAILS' ||
                  res.data.bannerMap['PC_JOURNAL_SWIPER_ASSOCIATED_MEDIA'][i]['urlType'] === 'LIST_EXHIBITOR'
                ) {
                  this.bannerAssociatedMedia.push(res.data.bannerMap['PC_JOURNAL_SWIPER_ASSOCIATED_MEDIA'][i])
                }
                // this.bannerAssociatedMedia.push(res.data.bannerMap['PC_JOURNAL_SWIPER_ASSOCIATED_MEDIA'][i])
              }
              this.bannerAssociatedMedia.sort(this.sortSequence)
            }

            console.log('this.bannerAssociatedMedia:', this.bannerAssociatedMedia)

          }
        })
    },
  },
  async mounted() { 
    console.log('修改')
    this.getHomeTopBannerList()
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/index'

.home-search{
  width:100%;
  background:#DAE3E8;
  padding:32px;
}
.home-search-input{
  width:798px;
  height:54px;
  line-height: 54px;
  border-radius: 6px;
  
  display: inline-block;
  border: 0;
  outline: none;
  font-size: 16px;
  padding:0 20px;
  padding-left:0px;
  ::v-deep input{
    height:54px;
    line-height: 54px;
    padding-left:35px;
  }

  &::placeholder {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.25);
  }
}
.home-search-btn{
  line-height:54px;
  padding:0 20px;
  background: linear-gradient( 90deg, #00875E 0%, #0068A9 100%);
  border-radius: 6px;
  color:#fff;
  font-size:18px;
  width: max-content;
}
.home-fenlei{
  width:100%;
  padding:32px 0;
  background:#F9F9F9;
  img{
    width: 100%;
    margin-bottom:0px;
  }
}
.home-zhanguan{
  width:100%;
  background:#fff;
  padding:32px 0 16px 0;
}
.home-zhanguan-main{
  max-width: 1280px;
  background:#fff;
  margin: 0 auto;
  
  img{
    width: 100%;
  }
}

.home-huiyizhou{
  width:100%;
  margin: 0;
}
.home-support-unit{
   max-width: 1280px;
   margin: 32px auto;
   .home-support-unit-col{
    min-width:630px;
  }
  .home-support-unit-title{
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    background: -webkit-linear-gradient(top, #00875E, #0068A9);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
  .home-support-unit-bg{
    height: 16px;
    background: linear-gradient( 90deg, #00875E 0%, #0068A9 100%);
    border-radius: 2px;
    opacity: 0.1;
    margin-top: -10px;
    width: 120%;
    margin-left: -10%;
  }
  .home-support-unit-box{
      
      padding:21px;
      border: 1px solid #00B31A;
      border-radius: 10px;
      // display: flex;
      // -webkit-disabled: flex;
      // justify-content: center;
      // align-items: center;
      // margin:0px;
      text-align:center;
      .swiper-container{
        height:120px;
      }
      .swiper-div{
        width: 100%;
        height: 100%;
        text-align: center;
        display: flex; 
        align-items: center;
        justify-content: center;
      }
      p{
        font-size: 14px;
        color: rgba(0,0,0,0.85);
        line-height: 28px;
        text-align:center;
      }
      img{
        height:24px;
      }
  }
}
.home-support-unit-div-medium{
  width:25%;
}
.vertical-bar{
  width:1px;
  height 60px;
  background:#00B31A;
  margin:0 20px;
}

::v-deep .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 100%;
    background: #fff;
    opacity: 1;
    margin: 0 4px;
}
/* 激活状态的分页器子弹样式 */
::v-deep .swiper-pagination-bullet-active {
    opacity: 1;
    background: linear-gradient( 90deg, #00875E 0%, #0068A9 100%);
    border-radius: 7px;
    width:48px;
}

@media (min-width: 320px) and (max-width: 750px) {
  .home-search{
    padding:16px;
  }
  .home-search-input{
    width:auto !important;  
  }
  .home-search-input{
    width:auto !important;  
    height:35px;
    line-height: 35px;
    border-radius: 6px;
    
    display: inline-block;
    border: 0;
    outline: none;
    font-size: 12px;
    padding:0 8px;
    padding-left:0px;
    ::v-deep input{
      height:35px;
      line-height: 35px;
      padding-left:30px;
    }

    &::placeholder {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.25);
    }
  }
  .home-search-btn{
    line-height:35px;
    padding:0 8px;
    background: linear-gradient( 90deg, #00875E 0%, #0068A9 100%);
    border-radius: 6px;
    color:#fff;
    font-size:11px;
    width: max-content;
  }
  .home-fenlei{
    width:100%;
    padding:16px 16px 0 16px;
    background:#F9F9F9;
    img{
      width: 100%;
      margin-bottom:16px;
    }
  }
  .home-support-unit{
    .home-support-unit-col{
      min-width:auto;
    }
    .home-support-unit-box{
      padding:21px;
      border: 1px solid #00B31A;
      border-radius: 10px;
      display: block;
      margin:0 10px;
      p{
        font-size: 14px;
        color: rgba(0,0,0,0.85);
        line-height: 28px;
        text-align:center;
      }
    }
  }
  .vertical-bar{
    width:100%;
    height 1px;
    background:#00B31A;
    margin:8px 0;
  }
  .home-support-unit-div-medium{
    width:100%;
  }

  ::v-deep .swiper-pagination-bullet {
    display none
  }
  /* 激活状态的分页器子弹样式 */
  ::v-deep .swiper-pagination-bullet-active {
      display none
  }
}

</style>